import React from "react";
import styled from "styled-components";
import { Ptag } from "./fonts";
import { Divider } from '@mui/material';

const PageTitle = ({ title }) => {
  return (
    <div style={{
      width: "930px"
    }}>
      <Ptag fontWeight="600" fontSize="32px" fontFamily="Merriweather">
        {title}
      </Ptag>
      <Divider sx={{margin: "2rem 0rem", borderColor: "#979797"}} />
    </div>
  );
};

export default PageTitle;
